<template>
    <div>
    <div class="py-3"></div>
    
    <v-card
        class="mx-auto"
        max-width="90%"
    >
    <v-toolbar
        :color="'light-blue darken-3'"
        dark
    >    
    <v-toolbar-title>사전예약 설정</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
        <v-btn
            color="blue-grey lighten-2"
            small
            fab
            v-bind="attrs"
            v-on="on"
        >
            <v-icon 
            color= "blue-grey darken-1"
            >mdi-help</v-icon>
        </v-btn>
    </template>
    <span>사전예약 이벤트 키값을 등록해야 통계를 이용할 수 있습니다.</span>
    </v-tooltip>
    </v-toolbar>

    
    <v-list>    
        <!-- 앱이름 -->
        <v-list-item>
        <span style="width:160px"><v-card-title style="font-weight:bold">이벤트 이름</v-card-title></span>
        <v-text-field
            label="이벤트 이름을 등록해주세요 (ex:뇌이버 사전예약 2022-10-22)"
            v-model="app_name"
            value=""            
        ></v-text-field> 
        </v-list-item>       

        <!-- 패키지 이름 -->
        <v-list-item>
        <span style="width:160px"><v-card-title style="font-weight:bold">패키지 이름</v-card-title></span>
        <v-text-field
            label="패키지 이름을 등록해주세요."
            v-model="app_package"
            value=""            
        ></v-text-field> 
        </v-list-item>       


        <!-- 패키지 이름 -->
        <v-list-item>
        <span style="width:160px"><v-card-title style="font-weight:bold">이벤트 키</v-card-title></span>
        <v-text-field
            label="이벤트 키는 난수로 자동 생성됩니다."
            v-model="app_event_tag"
            value=""    
            disabled        
        ></v-text-field> 
        </v-list-item>    

        <!-- 저장  -->
        <div class="py-1"></div>       
        <v-list-item>       
            <v-spacer></v-spacer>            
            <v-btn width="120px"  color="lime accent-3"  @click="OnSaveDone">등록하기</v-btn>
            <v-spacer></v-spacer>
        </v-list-item>       
        <div class="py-1"></div>
        
        <v-divider/>        


    </v-list>
    </v-card>
    
    <div class="py-3"></div>
    <div class="py-3"></div>



    <v-card
        class="mx-auto"
        max-width="90%"
    >
    <v-toolbar
        :color="'grey darken-1'"
        dark
    >    
    <v-toolbar-title>사전예약 이벤트 이력</v-toolbar-title>
    </v-toolbar>
    <v-list>
        <v-data-table         
        :footer-props="{'items-per-page-options':[30, -1]}"
        :headers="headers" 
        :items="table_list_history"
        :loading="loadingData"
        >        
        <template v-slot:item="row">            
            <tr>
            <td>{{row.item.event_name}}</td>
            <td>{{row.item.event_tag}}</td>            
            <td>{{row.item.package}}</td>
            <td>{{row.item.regist_user}}</td>
            <td>{{row.item.regist_date}}</td>
            </tr>
        </template>
        </v-data-table>
    </v-list>
    </v-card>
    </div>   
    
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment'
import store from '../../store';
import config from '../../config/config';
import { format, parseISO } from 'date-fns'
export default {
    name: 'UserList',

    data: () => ({
        loadingData:false,        
        app_name:'',
        app_package:'',
        app_event_tag:'',


        title_type_items:[],    //타이틀 설정 하도록 
        headers: [            
            { text: '이벤트 이름', value: 'event_name' },
            { text: '이벤트 태그', value: 'app_event_tag' },
            { text: '패키지 네임', value: 'package' },
            { text: '등록 관리자', value: 'admin' },
            { text: '등록 일자', value: 'regist_date' },
        ],
        table_list_history:[                     
        ]
    }),

    created()
    {
        //this.app_event_tag  = Math.random().toString(36) // "0.d4jcyu6965"
        this.app_event_tag  = Math.random().toString(36).substr(2,11); // "twozs5xfni"
        this.Refresh_ItemInfo();
        //this.app_event_tag = 'ff';
    },

    methods:{
        ...mapActions([
            'GET_LOG_HISTORY',
            'ADD_LOG_EVENT'
        ]),
        IsActiveState(_item)
        {
            return _item.active_yn=="Y"?true:false;
        },
        Refresh_ItemInfo()
        {
            this.GET_LOG_HISTORY().then((body_data)=>{
                console.log("GET_LOG_HISTORY"+JSON.stringify(body_data));
                let queryResult = body_data.qryResult;
                this.table_list_history = queryResult;
                //console.log(body_data.server_state.SERVICE_OPTION.item_opt);
            })
            .catch((err) => {
                this.error = err;
                console.log(err);
            })

        },
        OnSaveDone()
        {
            //$route.fullPath = 'http://localhost:8080/pre_reservation_regist';
            //this.$router.push('/game_mail?test=efs');
            let event_name = this.app_name;
            let event_key = this.app_event_tag;
            let packageName = this.app_package;
            
            this.ADD_LOG_EVENT({packageName , event_name, event_key}).then((body_data)=>{
                console.log("ADD_LOG_EVENT"+JSON.stringify(body_data));
                this.Refresh_ItemInfo();
                this.app_event_tag  = Math.random().toString(36).substr(2,11); // "twozs5xfni"
                //let queryResult = body_data.qryResult;
                //this.table_list_history = queryResult;
                //console.log(body_data.server_state.SERVICE_OPTION.item_opt);
            });

            // this.table_list_history.push({  
            //     event_name: '네이버 시청자 참여 이벤트네이버',
            //     package:'com.newday7.pantsceo',
            //     admin: 'justin',
            //     app_event_tag:'32112d',
            //     regist_date:'2021-10-10 12:00:00',
            // });
            
        },
    },
    computed: {
    },
    components:{
    },

};
</script>
